/* @ngInject */
function GoBackController ($scope, $state) {
  $scope.goToBoards = (state) => {
    if (state) {
      $state.go(`${state}`)
    } else {
      console.log('Directive goBack: You must pass either a function or a state')
    }
  }

  $scope.onButtonClick = () => {
    const state = $scope.state

    if ($scope.onClick && typeof $scope.onClick === 'function') {
      $scope.onClick()
    } else {
      $scope.goToBoards(state)
    }
  }
}

export { GoBackController }
